// 板発注画面 (市場板情報タブ) の 48 コマ ribbon の状態導出。
//
// spec `docs/specs/bidding/intraday-bidding.md` AC-BIN-025 が求める
// 「取引中 / GC済 / 開始前 の 3 状態」 を、 design `design/bidding/intraday-price.html`
// の `_buildKomaData` (`status = !_mktOpen ? 'upcoming' : GC済 ? 'closed' : 'trading'`)
// と同じ規則で導出する。
//
// - 未開場 (受渡日前日 17:00 前) は板が立っていないので全コマ 'pre' (= 開始前)
// - 開場後は GC 時刻の直接比較 ([[gcStatusOfKoma]]) で 'closed' / 'imminent' / 'trading'
//   ('imminent' = 今まさに GC を迎えるコマ。 design `.koma-chip.gc-active` に対応)
import { gcStatusOfKoma } from '~/pages/IntradayBidding/models/deliveryDate'
import { isMarketClosed } from '~/pages/IntradayBidding/models/marketOpen'

export type MarketKomaRibbonState = 'pre' | 'trading' | 'imminent' | 'closed'

export const marketKomaRibbonState = (
  now: Date,
  deliveryDate: Date,
  koma: number,
): MarketKomaRibbonState => {
  if (isMarketClosed(now, deliveryDate)) {
    return 'pre'
  }
  const status = gcStatusOfKoma(now, deliveryDate, koma)
  if (status === 'closed') return 'closed'
  if (status === 'imminent') return 'imminent'
  return 'trading'
}
